export const CREATE_DONATION_REQUEST = 'CREATE_DONATION_REQUEST';
export const CREATE_DONATION_SUCCESS = 'CREATE_DONATION_SUCCESS';
export const CREATE_DONATION_FAILURE = 'CREATE_DONATION_FAILURE';
export const FETCH_DONATION_REQUEST = 'FETCH_DONATION_REQUEST';
export const FETCH_DONATION_SUCCESS = 'FETCH_DONATION_SUCCESS';
export const FETCH_DONATION_FAILURE = 'FETCH_DONATION_FAILURE';
export const PATCH_DONATION_REQUEST = 'PATCH_DONATION_REQUEST';
export const PATCH_DONATION_SUCCESS = 'PATCH_DONATION_SUCCESS';
export const PATCH_DONATION_FAILURE = 'PATCH_DONATION_FAILURE';